import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, theme } from 'antd';
import {
  TeamOutlined,
  ApartmentOutlined,
  FileTextOutlined,
  FormOutlined,
  MailOutlined,
  UserOutlined,
  CommentOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';
import { MdSettings } from 'react-icons/md';
import { TbChartCohort } from 'react-icons/tb';
import { HiDocumentText } from 'react-icons/hi';
import PageWrapper from '../../../components/common/PageWrapper';
import PolicyCard from '../../../components/common/PolicyCard';
import { getSettingsCardRoutes } from '../../../utils/routeRegistry';
import {
  getCardPolicies,
  EMPTY_NAV_POLICY_CONFIG,
  loadNavPolicyConfig,
  subscribeNavPolicyConfig,
} from '../../../utils/navPolicyConfig';

const CARD_PRESENTATION = {
  '/settings/user_management': { icon: <TeamOutlined />, color: '#4F46E5' },
  '/settings/business_organisation_management': { icon: <ApartmentOutlined />, color: '#E11D48' },
  '/settings/business_organisation_data_management': { icon: <FileTextOutlined />, color: '#7C3AED' },
  '/settings/upload_sessions': { icon: <TbChartCohort />, color: '#0EA5E9' },
  '/settings/templates': { icon: <FileTextOutlined />, color: '#9333EA' },
  '/settings/system_templates': { icon: <FormOutlined />, color: '#0F766E' },
  '/settings/smtp_config': { icon: <MailOutlined />, color: '#16A34A' },
  '/settings/applicationUsers': { icon: <UserOutlined />, color: '#2563EB' },
  '/settings/feedback': { icon: <CommentOutlined />, color: '#F59E0B' },
  '/settings/data_management': { icon: <DatabaseOutlined />, color: '#0891B2' },
  '/settings/forms': { icon: <HiDocumentText />, color: '#6366F1' },
  '/settings/portal_posts': { icon: <FileTextOutlined />, color: '#0F766E' },
};

const ControlPanelScreen = () => {
  const { token } = theme.useToken();
  const [navPolicies, setNavPolicies] = useState(EMPTY_NAV_POLICY_CONFIG);

  useEffect(() => {
    let active = true;

    loadNavPolicyConfig()
      .then((config) => {
        if (active) setNavPolicies(config);
      })
      .catch(() => {
        if (active) setNavPolicies(EMPTY_NAV_POLICY_CONFIG);
      });

    const unsubscribe = subscribeNavPolicyConfig((config) => {
      if (active) setNavPolicies(config);
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  const cards = useMemo(
    () =>
      getSettingsCardRoutes().map((route) => {
        const presentation = CARD_PRESENTATION[route.path] || {};
        return {
          ...route,
          icon: route.icon || presentation.icon,
          color: presentation.color || token.colorPrimary,
          permission: getCardPolicies(navPolicies, route.path),
        };
      }),
    [navPolicies, token.colorPrimary],
  );

  return (
    <PageWrapper
      title="Control Panel"
      icon={<MdSettings size={24} />}
      showCard={false}
    >
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} sm={12} md={8} lg={6} xl={4} key={card.path}>
            <PolicyCard
              permission={card.permission}
              to={card.path}
              icon={card.icon}
              title={card.label}
              color={card.color}
            />
          </Col>
        ))}
      </Row>
    </PageWrapper>
  );
};

export default ControlPanelScreen;
